(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["b2b-quick-order"] && !Shopify.designMode) return;
  try {
    
    (function() {
      const root = document.querySelector('.b2b-qol');
      if (!root) return;
      const form = root.querySelector('[data-b2b-qol-form]');
      const subtotalEl = root.querySelector('[data-cart-subtotal]');
      const statusEl = root.querySelector('[data-b2b-qol-status]');
      const addBtn = form.querySelector('.b2b-qol__add-btn');
      const resetBtn = root.querySelector('[data-b2b-qol-reset]');
      const currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
      const moneyFormatter = new Intl.NumberFormat(undefined, { style: 'currency', currency: currency });
      function formatMoney(cents) { return moneyFormatter.format((cents || 0) / 100); }
      function setStatus(msg, type) {
        statusEl.textContent = msg || '';
        statusEl.className = 'b2b-qol__status' + (type ? ' b2b-qol__status--' + type : '');
      }
      function clampRow(row, requested) {
        const max = parseInt(row.dataset.maxQty, 10) || 0;
        if (max <= 0) return 0;
        return Math.max(0, Math.min(requested, max));
      }
      function recalc() {
        let subtotal = 0;
        root.querySelectorAll('.b2b-qol__row').forEach(row => {
          const unit = parseInt(row.dataset.unitPrice, 10) || 0;
          const qtyInput = row.querySelector('.b2b-qol__qty');
          const qty = parseInt(qtyInput.value, 10) || 0;
          const line = unit * qty;
          row.querySelector('[data-line-total]').textContent = formatMoney(line);
          subtotal += line;
        });
        subtotalEl.textContent = formatMoney(subtotal);
      }
      root.addEventListener('input', e => {
        if (e.target.classList.contains('b2b-qol__qty')) recalc();
      });
      root.addEventListener('change', e => {
        if (!e.target.classList.contains('b2b-qol__qty')) return;
        const row = e.target.closest('.b2b-qol__row');
        const requested = parseInt(e.target.value, 10) || 0;
        const clamped = clampRow(row, requested);
        if (clamped !== requested) {
          e.target.value = clamped;
          recalc();
        }
      });
      root.addEventListener('click', e => {
        const step = e.target.closest('.b2b-qol__step');
        if (step) {
          const qtyInput = step.parentElement.querySelector('.b2b-qol__qty');
          const row = qtyInput.closest('.b2b-qol__row');
          const cur = parseInt(qtyInput.value, 10) || 0;
          const delta = parseInt(step.dataset.step, 10);
          const next = clampRow(row, Math.max(0, cur + delta));
          qtyInput.value = next;
          recalc();
          return;
        }
        const maxBtn = e.target.closest('.b2b-qol__max');
        if (maxBtn && !maxBtn.disabled) {
          const row = maxBtn.closest('.b2b-qol__row');
          const max = parseInt(row.dataset.maxQty, 10) || 0;
          if (max > 0) {
            row.querySelector('.b2b-qol__qty').value = max;
            recalc();
          }
        }
      });
      function doReset() {
        root.querySelectorAll('.b2b-qol__qty').forEach(i => { i.value = 0; });
        recalc();
        setStatus('');
      }
      if (resetBtn) {
        resetBtn.addEventListener('click', doReset);
        resetBtn.addEventListener('keydown', e => {
          if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); doReset(); }
        });
      }
      function applyMax(el) {
        if (el.getAttribute('aria-disabled') === 'true') return;
        const row = el.closest('.b2b-qol__row');
        if (!row) return;
        const max = parseInt(el.dataset.maxQtyTrigger || row.dataset.maxQty || '0', 10);
        if (max > 0) {
          const input = row.querySelector('.b2b-qol__qty');
          input.value = max;
          recalc();
        }
      }
      root.querySelectorAll('.b2b-qol__max').forEach(el => {
        el.addEventListener('click', ev => { ev.preventDefault(); ev.stopPropagation(); applyMax(el); });
        el.addEventListener('keydown', ev => {
          if (ev.key === 'Enter' || ev.key === ' ') { ev.preventDefault(); applyMax(el); }
        });
      });
      form.addEventListener('submit', async e => {
        e.preventDefault();
        const items = [];
        root.querySelectorAll('.b2b-qol__row').forEach(row => {
          const qty = parseInt(row.querySelector('.b2b-qol__qty').value, 10) || 0;
          if (qty > 0) {
            items.push({ id: parseInt(row.dataset.variantId, 10), quantity: qty });
          }
        });
        if (!items.length) { setStatus('Add a quantity to at least one variant.', 'err'); return; }
        addBtn.disabled = true;
        setStatus('Adding ' + items.length + ' line' + (items.length === 1 ? '' : 's') + ' to cart…');
        try {
          const res = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items: items })
          });
          const data = await res.json();
          if (!res.ok) {
            setStatus(data.description || data.message || 'Could not add some items to cart.', 'err');
            addBtn.disabled = false;
            return;
          }
          setStatus('Added. Taking you to your cart…', 'ok');
          window.location.href = '/cart';
        } catch (err) {
          setStatus('Network error. Please try again.', 'err');
          addBtn.disabled = false;
        }
      });
      recalc();
    })();

  } catch(e) { console.error(e); }
})();
})();
